var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92883 0.375C9.74534 0.375 11.0136 1.62678 11.0136 3.42069V8.57931C11.0136 10.3732 9.74534 11.625 7.92883 11.625H3.58478C1.76826 11.625 0.5 10.3732 0.5 8.57931V3.42069C0.5 1.62678 1.76826 0.375 3.58478 0.375H7.92883ZM13.9685 2.15924C14.2977 1.99173 14.684 2.00924 14.9982 2.20721C15.3125 2.40442 15.5 2.74706 15.5 3.12168V8.87878C15.5 9.25416 15.3125 9.59604 14.9982 9.79325C14.8265 9.90061 14.6345 9.95543 14.441 9.95543C14.2797 9.95543 14.1185 9.91736 13.9677 9.84046L12.857 9.28005C12.446 9.07142 12.191 8.65264 12.191 8.18741V3.81228C12.191 3.34629 12.446 2.92751 12.857 2.72041L13.9685 2.15924Z",
    fill: "#F22B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.e8f56f33b0578e1b818fd7cb0ab0463b.svg";
export { ForwardRef as ReactComponent };